/**
 * 渠道结构健康诊断 - API 接口层
 * 与后端 Spring MVC REST API 对接
 */
import axios from 'axios'

const BASE_URL = '/api/diagnosis'

export default {
  /**
   * 查询BRM中该品牌的渠道数据
   * GET /api/diagnosis/brm/{brandName}
   */
  getBrmData(brandName) {
    return axios.get(`${BASE_URL}/brm/${encodeURIComponent(brandName)}`)
  },

  /**
   * 触发AI搜索
   * POST /api/diagnosis/ai-search
   * body: { brandName, industry }
   */
  aiSearch(brandName, industry) {
    return axios.post(`${BASE_URL}/ai-search`, { brandName, industry })
  },

  /**
   * 保存诊断结果
   * POST /api/diagnosis/save
   */
  saveDiagnosis(data) {
    return axios.post(`${BASE_URL}/save`, data)
  },

  /**
   * 获取历史诊断报告
   * GET /api/diagnosis/report/{sessionId}
   */
  getReport(sessionId) {
    return axios.get(`${BASE_URL}/report/${sessionId}`)
  },

  /**
   * 获取诊断历史列表
   * GET /api/diagnosis/history?page=1&size=20
   */
  getHistory(page = 1, size = 20) {
    return axios.get(`${BASE_URL}/history`, { params: { page, size } })
  },

  /**
   * 修改单项评分
   * PUT /api/diagnosis/score
   * body: { sessionId, questionId, score }
   */
  updateScore(sessionId, questionId, score) {
    return axios.put(`${BASE_URL}/score`, { sessionId, questionId, score })
  },

  /**
   * 删除诊断记录
   * DELETE /api/diagnosis/{sessionId}
   */
  deleteDiagnosis(sessionId) {
    return axios.delete(`${BASE_URL}/${sessionId}`)
  }
}
